import api from "../service/service";
import * as types from "../store/validacaoSolicitacao.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put } from "redux-saga/effects";
import validarSolicitacaoActions from "../store/validacaoSolicitacao.actions";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.DECA_VALIDACAO_POST, validar);
}

function* validar(action) {
  const { payload } = action;

  const result = yield call(api.validar, payload);
  yield put(validarSolicitacaoActions.setValidar(result.data));
}
